import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { UserDto } from 'src/app/models/user/user-dto';

@Injectable({
  providedIn: 'root'
})
export class AuthDispatcherService {
  private notificationSubject$: Subject<UserDto> = new Subject<UserDto>();
  private notification$: Observable<UserDto> =
    this.notificationSubject$.asObservable();

  publish(user: UserDto): void {
    this.notificationSubject$.next(user);
  }

  subscribe(handler: (msg: UserDto) => void): Subscription {
    return this.notification$.subscribe(handler);
  }

  unsubscribe(subscription: Subscription): void {
    subscription.unsubscribe();
  }

  complete(): void {
    this.notificationSubject$.complete();
  }
}
